import { FC, ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { LabelAndValue } from '@medtronic/pecc-react-component-library-js';
import { Grid, Typography } from '@mui/material';
import { DatasetSource } from '~/api/types';
import { useGetDatasetQuery } from '~/api/v2/hooks';
import { datasetDetailsPanelWrapperStyles } from '../styles';
import { DetailsDataConfig } from './types';

interface DatasetDetailsBlockProps {
  dataConfig: DetailsDataConfig[];
  title?: string;
}

const DatasetDetailsBlock: FC<DatasetDetailsBlockProps> = ({ dataConfig, title }) => {
  const datasetId = +useParams().id!;

  const { data } = useGetDatasetQuery({ datasetId });
  const isImagingDataset = data?.source === DatasetSource.IMAGING;

  if (!dataConfig.length) return null;

  return (
    <Grid container spacing={1} columns={12} sx={datasetDetailsPanelWrapperStyles}>
      {title && (
        <Grid size={{ xs: 12 }}>
          <Typography variant="h5" mx="1.6rem" mt="1.6rem">
            {title}
          </Typography>
        </Grid>
      )}
      {dataConfig.map(({ key, label, value, fullWidth, isImaging }) =>
        isImaging && !isImagingDataset ? null : (
          <Grid size={{ xs: fullWidth ? 12 : 6 }} key={key || label} sx={{ wordBreak: 'break-word' }}>
            <LabelAndValue label={label} value={(value as ReactNode) || '—'} />
          </Grid>
        ),
      )}
    </Grid>
  );
};

export default DatasetDetailsBlock;
